import * as Sentry from '@sentry/browser';

declare global {
  interface Window {
    TRACKING_DSN?: string;
  }
}

if (window['TRACKING_DSN']) {
  Sentry.init({
    dsn: window['TRACKING_DSN'],

    environment: 'production',
    release: `2026.9.1`,

    integrations: [Sentry.eventFiltersIntegration()],
    tracesSampleRate: 0.1,

    denyUrls: [
      'webmcp',
      'assets/shop_events_listener',
      'googleapis',
      'shopifysvc.com/v1/metrics',
      'cookieconfirm',
      'shop-js/modules',
      'web-pixels',
      'futy',
      'wpm',
      'otlp-http-production.shopifysvc.com',
    ],

    ignoreErrors: ['Network Error'],
  });
}
